// extracted by mini-css-extract-plugin
export default {"wave":"CallWaveform_wave__7jHax","bannerElemFadeIn":"CallWaveform_bannerElemFadeIn__6s9Bd","bar":"CallWaveform_bar__z8hJZ"};